<template>
  <div class="md-layout" >
    <!-- 主菜单表格 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <div class="md-layout" style="max-width: 500px;">
            <div class="md-layout-item md-size-50 left-layout-item md-xsmall-size-100">
              <md-field>
                <label>{{$I18n("product")}}</label>
                <md-select v-model="searchForm">
                  <md-option v-for="item in classData" :key="item.id" :value="item.id">{{item.name}}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50 left-layout-item md-xsmall-size-100">
              <md-field>
                <label>{{$I18n("company")}}</label>
                <md-select v-model="searchFormCompany">
                  <md-option v-for="item in compData" :key="item.comp_id" :value="item.comp_id">{{item.comp_name}}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-content>
          <add-button @click="table_addItem" v-if="UserInfo.role_id < 10000">{{$I18n("add_good")}}</add-button>
          <add-button @click="table_copyItem" v-if="UserInfo.role_id < 10000" style="margin-left: 16px;">{{$I18n("copy_good")}}</add-button>
          <md-table v-model="tableShowData" >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell :md-label="$I18n('good_name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('company_name')">{{ item.comp_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('effect_month')">{{ item.month }}</md-table-cell>
              <md-table-cell :md-label="$I18n('cost')">
                <p :style="{'margin': 0}">¥{{ item.comp_cn_price }}</p>
                <p :style="{'margin': 0}">¥{{ item.comp_other_price }}</p>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('fact_fee')">
                <p :style="{'margin': 0}">¥{{ item.rmb_fact_price }}</p>
                <p :style="{'margin': 0}">${{ item.usd_fact_price }}</p>
                <p :style="{'margin': 0}">{{$I18n("money_type_22")}}{{ item.inr_fact_price }}</p>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('sales_num')">{{ item.sales ?item.sales :0 }}</md-table-cell>
              <md-table-cell :md-label="$I18n('sort')">{{ item.sort }}</md-table-cell>
              <md-table-cell :md-label="$I18n('create_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')" class="button-box">
                <template v-if="item.name">
                  <md-button
                    @click.stop="table_editItem(item)"
                    class="md-just-icon md-round md-info left-icon"
                    ><md-icon>edit</md-icon></md-button
                  >
                  <md-button  v-if="UserInfo.role_id < 10000"
                    @click.stop="table_deleteItem(item)"
                    class="md-just-icon md-round md-danger md-info"
                    ><md-icon>close</md-icon></md-button
                  >
                </template>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "openModalType!=='delete' && openModalType!=='sub-delete'"
      :large = "true"
      @submit= "modal_submit"
      @close = "closeModal"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.Form.name)}}</div>
        <div v-else-if="openModalType==='sub-delete'">{{$I18n("check_delete", modalSubData.Form.name)}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else-if="openModalType === 'add' || openModalType === 'edit'" class="md-layout">
          <!-- 图片 -->
          <modal-form-item  class="md-layout-item md-size-100" :label='$I18n("icon")'>
            <div class="file-input">
              <div v-if="!imageRegular">
                <div @click="clickInput" class="image-container" :style="{'box-shadow': 'none'}">
                  <img :src="regularImg" title="" />
                </div>
              </div>
              <div @click="clickInput" class="image-container" :style="{'box-shadow': 'none'}" v-else>
                <img :src="imageRegular" />
              </div>
              <div>
                <md-button class="md-info md-round md-fileinput">
                  <template v-if="!imageRegular">{{$I18n("upload_img")}}</template>
                  <template v-else>{{$I18n("upload_img")}}</template>
                  <input ref="file_input" type="file" @change="onFileChange" />
                </md-button>
              </div>
            </div>
          </modal-form-item>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
          <!-- 子部分 -->
          <div class="md-layout-item md-layout md-size-100">
            <!-- 添加一个新的 -->
            <div class="md-layout-item mx-auto md-size-100" :style="{'text-align':'left'}">
              <md-button class="md-info" @click="modalData.Form.attrArray.push({key:'',value:''})">{{$I18n("add_attr")}}</md-button>
            </div>
            <div class="md-layout-item mx-auto md-size-50" v-for="(formItem, index) in modalData.Form.attrArray" :key="formItem.key" style="margin-left: 0 !important;">
              <md-card :style="{'margin-bottom':'5px'}">
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-45">
                      <md-field>
                        <md-select v-model="formItem.key" @md-selected="changedKey(formItem)">
                          <md-option value="">{{$I18n("attr")}}</md-option>
                          <md-option v-for="item in attrOption(formItem.key)" :key="item.key" :value="item.key" >
                            {{item.name}}
                          </md-option>
                        </md-select>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-45">
                      <md-field v-if="attr_value(formItem.key).length > 0">
                        <md-select v-model="formItem.value">
                          <md-option value="">{{$I18n("attr_value")}}</md-option>
                          <md-option v-for="item in attr_value(formItem.key)" :key="item" :value="item">
                            {{(parseInt(searchForm) === 101 && formItem.key === "type") 
                              ? $I18n($Param.videoGoodType.getName(item))
                              :item
                            }}
                          </md-option>
                        </md-select>
                      </md-field>
                      <!-- INPUT -->
                      <md-field v-else>
                        <md-input v-model="formItem.value"/>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-10">
                      <md-button 
                        @click="modalData.Form.attrArray.splice(index,1)" 
                        :style="{'float':'right'}"
                        class="md-primary md-sm md-info right-button md-just-icon md-round"
                      >
                        <md-icon>close</md-icon>
                      </md-button>
                    </div>
                  </div>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </div>
      </template>
    </simple-modal>
    <simple-modal 
      ref    = "copy_modal"
      :title = "$I18n('copy_good')"
      :large = "true"
      @submit= "modal_submit_copy"
      @close = "closeCopy"
    >
      <template slot="body">
        <div class="md-layout">
          <common-form-item type="select" class="md-layout-item md-size-20"
            v-model ="copy_class" :options="classData"
          />
         <div class="md-layout-item md-size-5" style="line-height: 59px">{{$I18n("from")}}</div>
          <common-form-item type="select" class="md-layout-item md-size-30"
            v-model ="copy_from" :options="compOptions"
          />
           
          <div class="md-layout-item md-size-15" style="line-height: 59px">{{$I18n("copy_to")}}</div>
          <common-form-item type="select" class="md-layout-item md-size-30"
            v-model ="copy_to"   :options="compOptions"
          />
          <div class="md-layout-item md-size-100 modalTable">
            <md-table v-model="copyTableData">
              <md-table-row @click="select_copy(item.id)" slot="md-table-row" slot-scope="{ item }">
                <md-table-cell class="table-checkbox"> 
                  <div class="unselect-box">
                    <md-icon v-if="copy_select.includes(item.id)" class="checkbox-color">done</md-icon>
                  </div>
                </md-table-cell>
                <md-table-cell :md-label="$I18n('good_name')">{{ item.name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('company_name')">{{ item.comp_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('effect_month')">{{ item.month }}</md-table-cell>
                <md-table-cell :md-label="$I18n('cost')">
                  <p :style="{'margin': 0}">¥{{ item.comp_cn_price }}</p>
                </md-table-cell>
                <md-table-cell :md-label="$I18n('fact_fee')">
                  <p :style="{'margin': 0}">¥{{ item.rmb_fact_price }}</p>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">
                {{$I18n("none_data")}}
              </md-table-empty-state>
            </md-table>
            <table-page :total="total" :pageSize="pageSize" v-model="copy_page"/>
          </div>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass, timestampToString1000 } from "@/common/tools.js";
export default {
  data() {
    return {
      copy_class : "",
      copy_from  : "",
      copy_to    : "",
      copy_goodD : [],
      copy_select: [],
      copy_page  : 1,
      copy_total : 0,
      // copy_size  : 10.

      searchFormCompany : 0,
      searchForm:"",

      imageRegular : "",
      regularImg : "/img/image_placeholder.jpg",

      // 表格相关
      icon  : "assignment",
      title : this.$I18n("product"),
      tableData : [], // 表格数据
      subTableData : [],
      // 是否打开弹窗
      openModalType : "add", // "delete" | "edit" | "sub-add" | "sub-edit" | "sub-delete"
      // 弹窗相关
      modalTitle : "",
      error: {
        name: false,
      },
      modalData     : new FormClass({
        name        : "",
        class_name  : "",
        comp_id     : 0,//this.searchFormCompany ?this.searchFormCompany : this.compData[0].comp_id,
        sort        : 0,
        state       : 1,
        month       : 0,
        inr_price : "",
        inr_fact_price  : "",
        usd_price : "",
        usd_fact_price  : "",
        rmb_price : "",
        rmb_fact_price  : "",
        link_type   : 1,
        only        : 2,
        type        : 2,
        limit       : 2,
        is_pay_disc : 1,
        stock       : "",
        other_id    : "",
        stripe_id   : "",
        razorpay_id : "",
        paypal_pid  : "",
        apple_pid   : "",
        // owner_id    : this.UserInfo.user_id,
        comp_cn_price : "",
        comp_other_price: "",
        img        : "",
        promotion_code: "",
        attrArray  : () => {return []},
      },{
        month        : "number",
        name         : "required",
        inr_price       : "number",
        inr_fact_price  : "number",
        usd_price       : "number",
        usd_fact_price  : "number",
        rmb_price       : "number",
        rmb_fact_price  : "number",
        // owner_id     : "required",
        stock : (val, formValue) => {
          if(formValue.limit === 1){
            return isNaN(val)
          } else {
            return false;
          }
        }
      }),
      compData : [],
      otherPlatData: [],
      classData: [],
      currentPage : 1,
      pageSize : 10,
      total : 0,

      init : false,
    };
  },
  mounted : function() {
    // this.api_getPageData();
    this.api_getCompany ()
      .then(() => {
        this.searchFormCompany = this.UserInfo.comp_id;
      })
      .then(() => {
        return this.api_getClass ()
          .then(() =>{
            if(this.classData.length == 0){
              return;
            }
            this.searchForm = this.classData[0].id;
            setTimeout(() => {
              this.api_getPageData ();
              this.init = true;
            }, 100);
          });
      });
    this.api_otherPlatform ();
  },
  watch: {
    copy_page(){
      this.api_getCopyData();
    },
    copy_class(){
      this.api_getCopyData();
    },
    copy_from(){
      this.api_getCopyData();
    },
    currentPage(){
      this.api_getPageData();
    },
    modalData:{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    searchFormCompany(){
      if(this.init){
        this.api_getPageData();
      }
    },
    searchForm(){
      if(this.init){
        this.api_getPageData();
      }
    },
  },
  computed: {
    compOptions(){
      return this.compData.map(i => {return{id: i.comp_id, name:i.comp_name}})
    },
    attrData(){
      const item = this.classData.filter(i => i.id == this.searchForm)[0]
      if(!item){
        return []
      }
      return JSON.parse(item.attr)
    },
    tableShowData (){
      return [...this.tableData]
        .map(item => {
          try{
            let companyData = this.compData.filter(comp => {
              return comp.comp_id == item.comp_id;
            })
            let comp_name = "";
            if(companyData.length > 0){
              comp_name = companyData[0].comp_name
            }
            let class_name = this.classData.filter(item => {
              return item.id == this.searchForm;
            })[0].name
            let attrArray = [];
            if(item.attr){
              let attrJSON = JSON.parse(item.attr)
              for(let key in attrJSON){
                attrArray.push({
                  key: key,
                  value: attrJSON[key],
                })
              }
            }
            return {
              ...item,
              comp_name,
              class_name,
              attrArray,
              create_time: timestampToString1000(item.gmt_create),
            }
          }catch{
            return {}
          }
        })
    },
    copyTableData (){
      return [...this.copy_goodD]
        .map(item => {
          let companyData = this.compData.filter(comp => {
            return comp.comp_id == item.comp_id;
          })
          let comp_name = "";
          if(companyData.length > 0){
            comp_name = companyData[0].comp_name
          }
          let class_name = this.classData.filter(item => {
            return item.id == this.searchForm;
          })[0].name
          let attrArray = [];
          if(item.attr){
            let attrJSON = JSON.parse(item.attr)
            for(let key in attrJSON){
              attrArray.push({
                key: key,
                value: attrJSON[key],
              })
            }
          }
          return {
            ...item,
            comp_name,
            class_name,
            attrArray,
          }
        })
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("class_name"),
          keys    : "class_name",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-50",
        // },{
        //   label   : this.$I18n("seller_id"),
        //   keys    : "owner_id",
        //   type    : "input",
        //   disabled: this.UserInfo.role_id >= 10000,
        //   required: true,
        //   check   : true,
        //   class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("company"),
          keys    : "comp_id",
          type    : "select",
          disabled: this.UserInfo.role_id >= 10000,
          placeholder:this.$I18n('pls_input_role_id'),
          class   : "md-layout-item md-size-50",
          options : this.compData.map(i => {
            return {
              id  : i.comp_id,
              name: i.comp_name,
            }
          })
        },{
          label   : this.$I18n("effect_month"),
          keys    : "month",
          type    : "input",
          disabled: this.UserInfo.role_id >= 10000,
          required: true,
          check   : true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("sort_num"),
          keys    : "sort",
          type    : "input",
          disabled: this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("sales_num"),
          keys    : "sales",
          type    : "input",
          hide    : this.openModalType !== 'edit',
          disabled: true,
          class   : "md-layout-item md-size-50",
        },{
          label   : this.$I18n("stock_state"),
          keys    : "state",
          type    : "select",
          options : [
            {id: 1, name :this.$I18n("upper_shelf")},
            {id: 2, name :this.$I18n("lower_shelf")},
          ],
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("only_sale_one"),
          keys    : "only",
          type    : "select",
          disabled: this.UserInfo.role_id >= 10000,
          options : [
            {id: 1, name :this.$I18n("open")},
            {id: 2, name :this.$I18n("close")},
          ],
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("orginal_fee"),
          keys    : "rmb_price",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("fact_fee"),
          keys    : "rmb_fact_price",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("orginal_usd_fee"),
          keys    : "usd_price",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("fact_usd_fee"),
          keys    : "usd_fact_price",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("orginal_inr_fee"),
          keys    : "inr_price",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("fact_inr_fee"),
          keys    : "inr_fact_price",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("comp_price"),
          keys    : "comp_cn_price",
          type    : "input",
          disabled: this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("comp_other_price"),
          keys    : "comp_other_price",
          type    : "input",
          disabled: this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("limit_stock_num"),
          keys    : "limit",
          type    : "select",
          options : [
            {id: 2, name :this.$I18n("unlimit")},
            {id: 1, name :this.$I18n("have_limit")},
          ],
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("stock_num"),
          keys    : "stock",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("good_type"),
          keys    : "link_type",
          type    : "select",
          options : [
            {id : 1, name : this.$I18n("single_mode")},
            {id : 2, name : this.$I18n("user_mod")}
          ],
          disabled: this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("bind_other_order_id"),
          keys    : "other_id",
          type    : "select",
          options : [
            {id : "", name : this.$I18n("un_bind")},
            ...this.otherPlatData.map(i => {
              return {
                id  : i.id,
                name: i.name,
              }
            })
          ],
          disabled: this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("stripe_price_id"),
          keys    : "stripe_id",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("razorpay_plan_id"),
          keys    : "razorpay_id",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("paypal_plan_id"),
          keys    : "paypal_pid",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("apple_pay_id"),
          keys    : "apple_pid",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("google_pay_id"),
          keys    : "google_pid",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("promo_code"),
          keys    : "promotion_code",
          type    : "input",
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n("is_pay_disc"),
          keys    : "is_pay_disc",
          type    : "select",
          options : [
            {id : 1, name : this.$I18n("open")},
            {id : 2, name : this.$I18n("closed")}
          ],
          class   : "md-layout-item md-size-25",
        }
      ]
    },
  },
  methods: {
    select_copy(id){
      if(this.copy_select.includes(id)){
        this.copy_select = this.copy_select.filter(i => i !== id);
      } else {
        this.copy_select = [...this.copy_select, id];
      }
    },
    closeModal (){
      document.getElementsByTagName("body")[0].style = ""
      if (this.openModalType === "add" || this.openModalType === "edit" || this.openModalType === "delete"){
        this.api_getPageData();
      }else {
        this.api_getPageDataOnlySub();
      }
    },
    closeCopy(){ 
      this.copy_goodD =[];
      this.copy_select=[];
    },
    changedKey(formItem){
      formItem.value="";
    },
    attrOption(key){
      return this.attrData.filter(attr => {
        return attr.key == key || !this.modalData.Form.attrArray.some(item => item.key == attr.key)
      })
    },
    attr_value (key) {
      if(!key) {
        return [];
      }
      try {
        var list = this.attrData.filter(item => {
          return item.key == key;
        })[0].value;
        if(list.length === 1 && list[0] == -1){
          return []
        }
        return list
      } catch (e) {
        return [];
      }
    },
    ...({ // 上传图片相关
      onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files  || !files.length) return;
        let reader = new FileReader();
        let vm = this;
        reader.onload = (e) => {
          vm.imageRegular = e.target.result;
        };

        var formData = new FormData();
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData)
          .then(this.$Then(res => {
            this.modalData.Form.img = res.data;
            reader.readAsDataURL(files[0]);
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      },
      clickInput(){
        this.$refs.file_input.click();
      },
    }),
    api_getCompany (){
      return this.$api.getCompanyList({ })
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.compData = [];
        }))
    },
    api_otherPlatform (){
      this.$api.getOtherPlatform({type :0 })
        .then(this.$Then(res => {
          this.otherPlatData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.otherPlatData = [];
        }))
    },
    api_getClass (){
      return this.$api.getGoodClass({ })
        .then(this.$Then(res => {
          this.classData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.classData = [];
        }))
    },
    // 获取页面信息
    api_getPageData(){
      //获取菜单
      return this.$api.getGood({ 
        comp_id : this.searchFormCompany === "__ALL__" ?"" :this.searchFormCompany,
        category_id: this.searchForm,
        seller_id : '',
        page_index : this.currentPage,
        page_size : this.pageSize,
        app_id: '',
        is_spec: 2,
      })
        .then(this.$Then(res => {
          this.tableData = res.data;
          this.total     = res.count;
        }))

        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableData = [];
          this.total = 0;
        }))
    },
    api_getCopyData(){
      //获取菜单
      return this.$api.getGood({ 
        comp_id    : this.copy_from,
        category_id: this.copy_class,
        seller_id  : '',
        page_index : this.copy_page,
        page_size  : this.pageSize,
        app_id     : '',
        is_spec    : 2,
      })
        .then(this.$Then(res => {
          this.copy_select= [];
          this.copy_goodD = res.data;
          this.copy_total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.copy_select= [];
          this.copy_goodD = [];
          this.copy_total = 0;
        }))
    },
    table_copyItem(){
      this.copy_class = this.searchForm;
      this.copy_from  = this.UserInfo.comp_id;
      this.copy_to    = this.searchFormCompany;
      this.copy_page  = 1;
      this.api_getCopyData();
      this.$refs.copy_modal.open();
    },
    // 新增角色
    table_addItem  (){
      this.modalTitle = this.$I18n("add_good");
      this.openModalType = "add";
      this.modalData.Reset();
      this.modalData.Form.comp_id    = this.searchFormCompany ?this.searchFormCompany : this.compData[0].comp_id;
      let fir_class = this.classData.filter(item => item.id == this.searchForm)[0];
      if(!fir_class) {
        this.$errorMsg(this.$I18n("pls_add_good_class"));
        return
      }
      this.modalData.Form.class_name = this.classData.filter(item => item.id == this.searchForm)[0].name;
      this.imageRegular = ""
      this.regularImg = "/img/image_placeholder.jpg"
      this.$refs.modal.open();
      document.getElementsByTagName("body")[0].style = "overflow: hidden;"
    },
    // 修改角色
    table_editItem (item){
      this.modalTitle = this.$I18n("edit_good");
      this.openModalType = "edit";
      this.modalData.Update({
        ...item,
        sort : item.sort ?item.sort :0,
        other_id : item.other_id ?item.other_id :"",
      });
      this.$refs.value  = this.modalData.Form.img;
      this.imageRegular = this.modalData.Form.img;
      this.$refs.modal.open();
      document.getElementsByTagName("body")[0].style = "overflow: hidden;"
    },
    // 删除角色
    table_deleteItem (item){
      this.modalTitle = this.$I18n("is_sure_del");
      this.openModalType = "delete";
      this.modalData.Update(item);
      this.$refs.modal.open();
      document.getElementsByTagName("body")[0].style = "overflow: hidden;"
    },
    // 提交表单
    modal_submit () {
      if(this.openModalType === "delete"){
        this.modal_submitDel();
      } else if (this.openModalType === "add") {
        this.modal_submitAdd();
      } else if (this.openModalType === "edit"){
        this.modal_submitEdit();
      } else if (this.openModalType === "sub-add") {
        this.modal_submitSubAdd();
      } else if (this.openModalType === "sub-edit"){
        this.modal_submitSubEdit();
      } else if (this.openModalType === "sub-delete"){
        this.modal_submitSubDel();
      }
    },
    // 提交复制商品列表
    modal_submit_copy(){
      if(this.copy_to === this.copy_from){
        this.$errorMsg(this.$I18n("select_different_comp"));
        return
      }
      this.loop_copy_update(this.copy_goodD.filter(i => this.copy_select.includes(i.id)));
    },
    loop_copy_update (loopArray) {
      let good = loopArray.pop();
      if(!good){
        this.$successMsg(this.$I18n("add_success"));
        this.api_getPageData();
        this.$refs.copy_modal.close();
        return
      }
      this.$api.addGood({
        ...good,
        comp_id: this.copy_to,
      })
        .catch(() => {})
        .then(() => {
          this.loop_copy_update(loopArray);
        })
    },
    modal_submitAdd () {
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      let attr  = {}
      this.modalData.Form.attrArray.forEach(item => {
        if(item.value){
          attr[item.key] = item.value;
        }
      });
      if(isNaN(this.modalData.Form.comp_cn_price) || this.modalData.Form.comp_cn_price === ""){
        this.modalData.Form.comp_cn_price = "0.00";
      }
      if(isNaN(this.modalData.Form.comp_other_price) || this.modalData.Form.comp_other_price === ""){
        this.modalData.Form.comp_other_price = "0.00";
      }
      this.$api.addGood({
        ...this.modalData.Form,
        type: 3,
        category_id : this.searchForm,
        attr: JSON.stringify(attr),
      })
        .then(this.$Then(res => {
          this.modalData.Form.id = res.data.id;
          this.$successMsg(this.$I18n("add_success"));
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(this.$I18n("add_fail")))
    },
    modal_submitEdit () {
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      let attr  = {}
      this.modalData.Form.attrArray.forEach(item => {
        if(item.value){
          attr[item.key] = item.value;
        }
      })
      if(isNaN(this.modalData.Form.comp_cn_price) || this.modalData.Form.comp_cn_price === ""){
        this.modalData.Form.comp_cn_price = "0.00";
      }
      if(isNaN(this.modalData.Form.comp_other_price) || this.modalData.Form.comp_other_price === ""){
        this.modalData.Form.comp_other_price = "0.00";
      }
      this.$api.editGood({
        ...this.modalData.Form,
        type: 3,
        attr: JSON.stringify(attr),
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(this.$I18n("edit_fail")))
    },
    modal_submitDel (){
      this.$api.delGood({
        ...this.modalData.Form,
      })
        .then(this.$Then(res => {
          if(res.code == "1024"){
            this.$errorMsg(this.$I18n("error_code_1024"));
            this.$refs.modal.close();
            return 
          }
          this.$successMsg(this.$I18n("delete_success"));
          this.$refs.modal.close();
        },["1024"]))
        .catch(this.$Catch(this.$I18n("delete_fail")))
    },
  },
}
</script>
<style lang="scss" scoped>
  .unselect-box{
    width : 28px;
    height: 28px;
    border: 2px solid #9c27b0 !important;
    border-radius: 4px;
  }
  .modalTable {
    text-align: left !important;
  }
  modalTable:hover{
    cursor: pointer;
  }
  .md-layout {
    overflow: hidden;
  }
  // 弹窗内组件

  //表格里的多选框
    .checkbox-color{
      color: #9c27b0  !important;
    }
    .table-checkbox {
      width: 80px;
    }
    .table-checkbox  .md-checkbox{
      margin: 0;
    }
    .table-selected{
      text-align: left;
      width: 100%;
    }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗的表单
  .md-form-label{
    color: #aaa;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    padding-top: 20px ;
    text-align: left;
  }
  .md-layout-left{
    text-align: left;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 100px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon {
    margin-right: 20px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>